import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CallButton from "@/components/CallButton";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const MentionsLegales = () => {
  return <>
      <SEO title="Mentions Légales - Tolstoï Serrurier" description="Mentions légales et informations juridiques de Tolstoï Serrurier, serrurier professionnel à Villeurbanne et Lyon." canonical="https://www.tolstoi-serrurier.fr/mentions-legales" />
      
      <div className="min-h-screen flex flex-col bg-background">
        <Header />
        
        <main className="flex-grow">
          <div className="container mx-auto px-4 py-8 max-w-4xl">
            <Breadcrumbs items={[{
            label: "Accueil",
            href: "/"
          }, {
            label: "Mentions Légales",
            href: "/mentions-legales"
          }]} />
            
            <h1 className="text-4xl font-bold mb-8 text-foreground">Mentions Légales</h1>
            
            <div className="space-y-6">
              <Card>
                <CardHeader>
                  <CardTitle>Éditeur du site</CardTitle>
                </CardHeader>
                <CardContent className="space-y-2">
                  <p><strong>Nom de l'entreprise :</strong> Tolstoï Serrurier</p>
                  <p><strong>Adresse :</strong> Villeurbanne, France</p>
                  <p><strong>Téléphone :</strong> 04 82 53 16 08</p>
                  <p><strong>Email :</strong> serruriertolstoi@gmail.com</p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Hébergement</CardTitle>
                </CardHeader>
                <CardContent className="space-y-2">
                  <p><strong>Hébergeur :</strong> Lovable (GPE)</p>
                  <p><strong>Adresse :</strong> 651 N Broad St, Suite 201, Middletown, DE 19709, USA</p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Propriété intellectuelle</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est la propriété exclusive de Tolstoï Serrurier, 
                    sauf mention contraire. Toute reproduction, distribution, modification, adaptation, retransmission ou publication 
                    de ces différents éléments est strictement interdite sans l'accord écrit de Tolstoï Serrurier.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Données personnelles</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-muted-foreground">
                    Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, 
                    de rectification, de suppression et de portabilité de vos données personnelles.
                  </p>
                  <p className="text-muted-foreground">
                    Les informations collectées via notre formulaire de contact sont uniquement destinées à traiter votre demande 
                    et ne seront en aucun cas transmises à des tiers.
                  </p>
                  <p className="text-muted-foreground">
                    Pour exercer vos droits, contactez-nous à : serruriertolstoi@gmail.com
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Cookies</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    Ce site utilise des cookies pour améliorer votre expérience de navigation. En poursuivant votre navigation 
                    sur ce site, vous acceptez l'utilisation de cookies. Vous pouvez à tout moment modifier vos préférences 
                    via les paramètres de votre navigateur.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Responsabilité</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    Tolstoï Serrurier s'efforce de fournir des informations aussi précises que possible sur ce site. 
                    Toutefois, nous ne pouvons garantir l'exactitude, la complétude et l'actualité des informations diffusées. 
                    En conséquence, l'utilisateur reconnaît utiliser ces informations sous sa responsabilité exclusive.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Liens hypertextes</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    Ce site peut contenir des liens vers d'autres sites. Tolstoï Serrurier ne peut être tenu responsable 
                    du contenu de ces sites externes ni des éventuels dommages résultant de leur utilisation.
                  </p>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Droit applicable</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">
                    Les présentes mentions légales sont soumises au droit français. En cas de litige, 
                    les tribunaux français seront seuls compétents.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </main>
        
        <Footer />
        <CallButton />
      </div>
    </>;
};
export default MentionsLegales;
